import { render, staticRenderFns } from "./profile.page.vue?vue&type=template&id=c3944cd0&scoped=true&"
import script from "./profile.page.vue?vue&type=script&lang=js&"
export * from "./profile.page.vue?vue&type=script&lang=js&"
import style0 from "./profile.page.vue?vue&type=style&index=0&id=c3944cd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3944cd0",
  null
  
)

export default component.exports